module.exports = __webpack_public_path__ + "static/media/privacy-photo2-3.e385cf81.png";